<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/shop-guide/">ショップガイド</router-link></li>
          <li v-if="shopGuideDetail.acf?.shop_name != ''"><router-link :to="'/shop-guide/' + shopGuideDetail.id">{{shopGuideDetail.acf?.shop_name}}</router-link></li>
          <li v-else><router-link :to="'/shop-guide/' + shopGuideDetail.id">{{shopGuideDetail.acf?.explanation}}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="shopguide-detail">
      <div class="container">
        <div class="container-child">
          <div class="shopguide-detail__title">
            <h2 v-if="!isLoading">SHOP GUIDE<span>ショップガイド詳細</span></h2>
            <div class="skeleton-parent" v-if="isLoading">
              <PuSkeleton style="height: 60px;" :count="1"/>
            </div>
          </div>
          
          <div class="shopguide-detail__cont">
            <div class="list">
              <div class="item">
                <div class="wrap-img" v-if="shopGuideDetail.acf?.shop_image || shopGuideDetail.acf?.shop_name && !isLoading && shopGuideDetail.acf?.shop_image != '' || shopGuideDetail.acf?.shop_image != false" 
                  :style="{ backgroundImage: `url(${$func.formatUrl(shopGuideDetail.acf?.shop_image)})` }">
                  <img :src="$func.formatUrl(shopGuideDetail.acf?.shop_image)" :alt="shopGuideDetail.acf?.shop_name">
                </div>
                <div class="wrap-img" v-if="shopGuideDetail.acf?.shop_image === '' || shopGuideDetail.acf?.shop_image === false" 
                  :style="{ backgroundImage: `url(${(urlNowRinting.url)})` }">
                  <img :src="urlNowRinting.url" :alt="urlNowRinting.alt" /> 
                </div>
                <div class="skeleton-parent" v-if="isLoading">
                  <PuSkeleton style="height: 300px;" :count="1"/>
                </div>
              </div>
              <div class="item">
                <div class="acsein">
                  <ul class="list-tag" v-if="shopGuideDetail.acf?.shop_type && !isLoading">
                    <li :class="shopGuideDetail.acf?.shop_type === '飲食' ? '' : 'txt_b_custom'" v-if="shopGuideDetail.acf?.shop_type === '飲食' && shopGuideDetail.acf?.shop_type != null && shopGuideDetail.acf?.shop_type != ''">{{ shopGuideDetail.acf?.shop_type }}</li>
                    <li :class="shopGuideDetail.acf?.shop_type === 'その他' ? 'txt_b_custom' : ''" v-if="shopGuideDetail.acf?.shop_type === 'その他' && shopGuideDetail.acf?.shop_type != null && shopGuideDetail.acf?.shop_type != ''">{{ shopGuideDetail.acf?.shop_type }}</li>
                  </ul>
                  <div class="skeleton-parent" v-if="isLoading">
                    <PuSkeleton :count="1"/>
                  </div>
                  <div class="acsein-top" v-if="!isLoading">
                    <div class="acsein-top__img" v-if="shopGuideDetail.acf?.shop_logo_image">
                      <img :src="$func.formatUrl(shopGuideDetail.acf?.shop_logo_image)" alt="shopguide-detail-acsein">
                    </div>
                    <div class="acsein-top__title" v-if="shopGuideDetail.acf?.shop_name || shopGuideDetail.acf?.shop_id">{{ shopGuideDetail.acf?.shop_id + '.' + shopGuideDetail.acf?.shop_name }}</div>
                  </div>
                  <div class="skeleton-parent" v-if="isLoading">
                    <PuSkeleton style="height: 100px;" :count="1"/>
                  </div>
                </div>
                <div class="cont-custom">
                  <div class="acreage" v-if="shopGuideDetail.acf?.shop_area || shopGuideDetail.acf?.shop_floor && !isLoading">{{ shopGuideDetail.acf?.shop_area + shopGuideDetail.acf?.shop_floor }}</div>
                  <div class="skeleton-parent" v-if="isLoading" style="margin-top: 20px; margin-bottom: 20px;">
                    <PuSkeleton :count="1"/>
                  </div>
                  <div class="content__hour" v-if="!isLoading">
                    <p>営業時間：</p>
                    <p v-if="shopGuideDetail.acf?.shop_hours" class="shop__hours">{{ shopGuideDetail.acf?.shop_hours }}</p>
                  </div>
                  <div class="skeleton-parent" v-if="isLoading" style="margin: 10px 0;">
                    <PuSkeleton style="height: 20px;" :count="1"/>
                  </div>
                  <div class="tel" v-if="shopGuideDetail.acf?.shop_tel && !isLoading">TEL：<a :href="'tel:' + shopGuideDetail.acf?.shop_tel">{{ shopGuideDetail.acf?.shop_tel }}</a></div>
                  <div class="skeleton-parent" v-if="isLoading">
                    <PuSkeleton :count="1"/>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="cont-leaflets" v-if="
                  (shopGuideDetail.acf?.file1 &&
                  shopGuideDetail.acf?.file_name1) ||
                  (shopGuideDetail.acf?.file2 &&
                  shopGuideDetail.acf?.file_name2) ||
                  (shopGuideDetail.acf?.file3 &&
                  shopGuideDetail.acf?.file_name3) ||
                  (shopGuideDetail.acf?.file4 &&
                  shopGuideDetail.acf?.file_name4) ||
                  (shopGuideDetail.acf?.file5 &&
                  shopGuideDetail.acf?.file_name5) && !isLoading
                ">
                <h3>イベントチラシ</h3>
                <ul>
                  <li v-if="shopGuideDetail.acf?.file1 && shopGuideDetail.acf?.file_name1">
                    <a target="_blank" :href="$func.formatUrl(shopGuideDetail.acf?.file1)">{{ shopGuideDetail.acf?.file_name1 }}</a>
                  </li>
                  <li v-if="shopGuideDetail.acf?.file2 && shopGuideDetail.acf?.file_name2">
                    <a target="_blank" :href="$func.formatUrl(shopGuideDetail.acf?.file2)">{{ shopGuideDetail.acf?.file_name2 }}</a>
                  </li>
                  <li v-if="shopGuideDetail.acf?.file3 && shopGuideDetail.acf?.file_name3">
                    <a target="_blank" :href="$func.formatUrl(shopGuideDetail.acf?.file3)">{{ shopGuideDetail.acf?.file_name3 }}</a>
                  </li>
                  <li v-if="shopGuideDetail.acf?.file4 && shopGuideDetail.acf?.file_name4">
                    <a target="_blank" :href="$func.formatUrl(shopGuideDetail.acf?.file4)">{{ shopGuideDetail.acf?.file_name4 }}</a>
                  </li>
                  <li v-if="shopGuideDetail.acf?.file5 && shopGuideDetail.acf?.file_name5">
                    <a target="_blank" :href="$func.formatUrl(shopGuideDetail.acf?.file5)">{{ shopGuideDetail.acf?.file_name5 }}</a>
                  </li>
                </ul>
                </div>
                <div class="skeleton-parent" v-if="isLoading">
                  <PuSkeleton style="height: 120px;" :count="1"/>
                </div>
              </div>
              <div class="item">
                <div class="cont-custom" v-if="shopGuideDetail.acf?.site_url || shopGuideDetail.acf?.link_url || shopGuideDetail.acf?.explanation">
                  <ul class="list-index" v-if="shopGuideDetail.acf?.site_url || shopGuideDetail.acf?.link_url && !isLoading">
                    <li v-if="shopGuideDetail.acf?.site_url != null && shopGuideDetail.acf?.site_url != '' && shopGuideDetail.acf?.site_url"><a target="_blank" :href="shopGuideDetail.acf?.site_url">公式ホームページ</a></li>
                    <li v-if="shopGuideDetail.acf?.link_url != null && shopGuideDetail.acf?.link_url != '' && shopGuideDetail.acf?.link_url"><a target="_blank" :href="shopGuideDetail.acf?.link_url">{{ shopGuideDetail.acf?.link_url }}</a></li>
                  </ul>
                  <div class="skeleton-parent" v-if="isLoading">
                    <PuSkeleton :count="2"/>
                  </div>
                  <div class="text" v-if="shopGuideDetail.acf?.explanation && !isLoading">
                    <p v-if="shopGuideDetail.acf?.explanation" v-html="shopGuideDetail.acf?.explanation"></p>
                  </div>
                  <div class="skeleton-parent" v-if="isLoading">
                    <PuSkeleton style="height: 100px; margin-bottom: 20px;" :count="1"/>
                  </div>
                </div>
                <!-- <div class="cont-silink">
                  <ul class="silink__list">
                    <li class="silink__list__item">
                      <a 
                        target="_blank"
                        :href="`https://social-plugins.line.me/lineit/share?url=${shopGuideDetailUrl}`"
                        ><img src="@/assets/img/common/si_line.svg" alt="line"
                      /></a>
                    </li>
                    <li class="silink__list__item">
                      <a 
                        target="_blank"
                        :href="`https://twitter.com/intent/tweet?text=${shopGuideDetailUrl}`"
                        ><img
                          src="@/assets/img/common/si_twitter.svg"
                          alt="twitter"
                      /></a>
                    </li>
                    <li class="silink__list__item">
                      <a 
                        target="_blank" 
                        :href="`https://www.facebook.com/sharer/sharer.php?u=${shopGuideDetailUrl}`"
                        ><img
                          src="@/assets/img/common/si_facebook.svg"
                          alt="facebook"
                      /></a>
                    </li>
                    <li class="silink__list__item">
                      <a 
                        :href="`mailto:?body=${shopGuideDetailUrl}`"
                        aria-current="page" 
                        class="router-link-exact-active router-link-active">
                        <img src="@/assets/img/common/si_mail.svg" alt="mail">
                      </a>
                    </li>
                  </ul>
                </div> -->
              </div>
              <div class="item">
                <div class="btn-list">
                  <router-link to="/shop-guide">ショップガイド(一覧)</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cont-shopnew" v-if="relationShopNewsDetail.length != 0">
        <div class="container">
          <div class="container-child">
            <div class="shopnew__title">
              <h2>SHOP NEWS<span>ショップニュース</span></h2>
            </div>
            <div class="shopnew-list">
              <fragment v-for="(item, index) in relationShopNewsDetail" :key="index">
                <div class="shopnew-list__item" v-if="index <= 2">
                  <router-link class="itemstatus__new" :to="'/shop-news/' + item.id" v-if="item.acf?.delivery_media.includes(dataFilter.town)">
                    <div class="itemstatus__new__banner"  v-if="diffDate(item.acf?.start_date + ' ' + item.acf?.start_time) <= 7">
                      <img src="@/assets/img/top/portal_icon.svg" alt="icon new">
                      <div class="itemstatus__new__banner__text">NEW</div>
                    </div>
                    <div v-if="item.acf?.news_image1 || item.acf?.title && item.acf?.news_image1 != '' || item.acf?.news_image1 != false" 
                      class="item__img" 
                      :style="{backgroundImage: `url(${$func.formatUrl(item.acf?.news_image1)})`}">
                      <img :src="$func.formatUrl(item.acf?.news_image1)" :alt="item.acf?.title">
                    </div>
                    <div v-if="item.acf?.news_image1 === '' || item.acf?.news_image1 === false" 
                      class="item__img" 
                      :style="{ backgroundImage: `url(${(urlNowRinting.url)})` }">
                      <img :src="urlNowRinting.url" :alt="urlNowRinting.alt" /> 
                    </div>
                    <div class="item__text">
                      <span class="item__date" v-if="item.acf?.start_date">公開日：<span>{{ formatDate(item.acf?.start_date) }}</span>({{ formatWeekDay(item.acf?.start_date) }})</span>
                      <ul class="item__cate" v-if="item.acf?.category">
                        <li v-if="item.acf?.category">{{ item.acf?.category }}</li>
                      </ul>
                      <span class="item__title" v-if="item.acf?.title">{{ item.acf?.title }}</span>
                      <p v-html="item.acf?.explanation" v-if="item.acf?.explanation"></p>
                    </div>
                  </router-link>
                </div>
              </fragment>
            </div>
            <div class="btn-list">
              <router-link to="/shop-news">ショップニュース一覧</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import moment from "moment";
import { Fragment } from "vue-fragment";
import { RouterLink } from "vue-router";
import CONSTANT from "../../../constant.js";
import { getUrl, metaData, formatUrlDetail } from '@/utils/helper';

export default {
  name: 'ShopGuideDetail',
  components: {
    Fragment
  },
  data() {
    return {
      shopGuideDetail: [],
      relationShopNewsDetail: [],
      isLoading: true,
      urlNowRinting: CONSTANT.dataImageNowrinting,
      dataFilter: CONSTANT.dataFilter[0],
      shopGuideDetailUrl: window.location.href,
    };
  },
  mounted() {
    // const listSlider = this.$el.querySelectorAll(".item__img");
    // listSlider.forEach((element) => {
    //   element.style.backgroundImage = `url(${
    //       element.querySelector("img").src
    //   })`;
    // });
    // const getImgage = this.$el.querySelector('.wrap-img img');
    // this.$el.querySelector('.wrap-img').style.backgroundImage = `url(${getImgage.src})`
  },
  computed: {
    currentDate() {
      return moment().format("YYYY/MM/DD");
    },
  },
  methods: {
    formatUrlDetail,
    formatDate(shopNews) {
      return moment(shopNews.replaceAll('/', '-')).format("YYYY/MM/DD");
    },
    formatWeekDay(shopguide) { 
      moment.locale('ja'); 
      const d = moment(shopguide.replaceAll('/', '-')).format("dd"); 
      return d; 
    },
    diffDate(shopguide) {
      var start = moment(shopguide.replaceAll('/', '-'));
      var current = moment();
      return current.diff(start, 'days')
    },
    relationShopNews(relationShopNewsId) {
      getUrl('/shop_news', {_fields: 'id,date,acf'})
      .then((result) => {
        let dataShopNews = this.$func.filterByDeliveryMedia(result.data)
        let listPostRelative = dataShopNews.filter(x => relationShopNewsId.includes(x.id));

        this.relationShopNewsDetail = this.$func.sortByPublicDate(listPostRelative) || [];
      })
    }
  },
  created() {
    this.isLoading = true
    getUrl(`/shop_guide/${this.$route.params.id}`)
      .then((response) => {
        this.shopGuideDetail = response.data;
        metaData(
          `${this.shopGuideDetail.acf?.shop_name ? this.shopGuideDetail.acf?.shop_name : ''} | HARUMIFLAGタウンポータル`,
          '',
          'HARUMIFLAGタウンポータル',
          'article',
          `${formatUrlDetail(this.shopGuideDetail.acf?.shop_image)}`
        )
        let relationShopNewsId = response.data?.acf?.relation_shop_news || [];
        this.relationShopNews(relationShopNewsId)

        this.isLoading = false
      })
      .catch((e) => {
        console.log(e);
        this.$router.push('/NotFound')
      });
  },
}
</script>